import { render, staticRenderFns } from "./deleteQuestionAnswer.vue?vue&type=template&id=5ad76ef4"
import script from "./deleteQuestionAnswer.vue?vue&type=script&lang=js"
export * from "./deleteQuestionAnswer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports